/**
 * 고객사 관리 관련 상수 정의
 * 고객사 관리 탭 등을 중앙에서 관리
 */

// ============================================
// 고객사 관리 탭
// ============================================
export const CUSTOMER_MANAGEMENT_TABS = {
  LIST: 'list',
  DASHBOARD: 'dashboard',
} as const;

// ============================================
// 타입 정의
// ============================================
export type CustomerManagementTab = typeof CUSTOMER_MANAGEMENT_TABS[keyof typeof CUSTOMER_MANAGEMENT_TABS];
